import { render, staticRenderFns } from "./PhoneDetails.vue?vue&type=template&id=8c4357be&scoped=true&"
import script from "./PhoneDetails.vue?vue&type=script&lang=js&"
export * from "./PhoneDetails.vue?vue&type=script&lang=js&"
import style0 from "./PhoneDetails.vue?vue&type=style&index=0&id=8c4357be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4357be",
  null
  
)

component.options.__file = "PhoneDetails.vue"
export default component.exports